import React, { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { api } from '@/lib/api';
import { Calendar, MapPin, Users, Sparkles } from 'lucide-react';
import { toast } from 'sonner';

export default function OverviewTab({ event, isOrganizer, reload }) {
  const [busy, setBusy] = useState(false);
  const rsvp = async (status) => {
    setBusy(true);
    try { await api.post(`/events/${event.id}/rsvp`, { status }); toast.success(`RSVP: ${status}`); reload && reload(); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Failed'); }
    finally { setBusy(false); }
  };
  return (
    <div className="space-y-3" data-testid="overview-tab">
      <Card className="rounded-2xl p-4">
        <div className="text-xs uppercase tracking-wider text-muted-foreground mb-1">About</div>
        <p className="text-sm whitespace-pre-line">{event.description || 'No description yet.'}</p>
      </Card>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <Card className="rounded-2xl p-4">
          <div className="text-xs uppercase tracking-wider text-muted-foreground mb-2">Schedule</div>
          <div className="text-sm flex items-center gap-2"><Calendar className="h-4 w-4" />{fmtDate(event.start_date)} → {fmtDate(event.end_date)}</div>
          {event.location_text && <div className="mt-1 text-sm flex items-center gap-2"><MapPin className="h-4 w-4" />{event.location_text}</div>}
          {event.origin && <div className="mt-1 text-sm flex items-center gap-2"><MapPin className="h-4 w-4" />From: {event.origin}</div>}
          {event.destination && <div className="mt-1 text-sm flex items-center gap-2"><MapPin className="h-4 w-4" />To: {event.destination}</div>}
        </Card>
        <Card className="rounded-2xl p-4">
          <div className="text-xs uppercase tracking-wider text-muted-foreground mb-2">Stats</div>
          <div className="flex items-center gap-2 text-sm"><Users className="h-4 w-4" />{event.participant_count} participants</div>
          <div className="mt-1 flex items-center gap-2 text-sm"><Sparkles className="h-4 w-4" />{event.media_count ?? 0} media items</div>
        </Card>
      </div>
      <Card className="rounded-2xl p-4">
        <div className="text-xs uppercase tracking-wider text-muted-foreground mb-2">Your RSVP</div>
        <div className="flex gap-2 flex-wrap">
          <Button onClick={() => rsvp('going')} disabled={busy} data-testid="rsvp-going" className="rounded-xl gradient-fab text-white">Going</Button>
          <Button onClick={() => rsvp('maybe')} disabled={busy} variant="outline" data-testid="rsvp-maybe" className="rounded-xl">Maybe</Button>
          <Button onClick={() => rsvp('declined')} disabled={busy} variant="outline" data-testid="rsvp-declined" className="rounded-xl">Decline</Button>
        </div>
      </Card>
    </div>
  );
}

function fmtDate(s) {
  try { return new Date(s).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }); }
  catch (e) { return s; }
}
